<template>
  <div class="row">
    <div class="col-lg-12 tab-index">
      <div class="d-flex">
        <!-- <span class="icon-right"></span> -->

        <ul>
          <router-link
            v-for="(val, index) in tabs"
            tag="li"
            :to="`/${username}/${route[index]}`"
            class="d-flex"
            :key="index"
          >
            <i :class="[val.icon,'nav-link']"></i>
            <a class="nav-link" href="#">{{val.title}}</a>
          </router-link>
        </ul>

        <!-- <span class="icon-left"></span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: ["tabs"],
  data() {
    return {
      route: {
        about: "about",
        point: "point",
        comment: "comment",
        product: "product",
        group: "group",
        gallery: "gallery",
        service: "service",
        facility: "facility",
        information: "info",
        posts: "posts",
      },
    };
  },
  computed: {
    username() {
      return this.$route.params.username;
    },
  },
};
</script>